import { render, staticRenderFns } from "./HighlightsField.vue?vue&type=template&id=464c8458&scoped=true"
import script from "./HighlightsField.vue?vue&type=script&lang=ts"
export * from "./HighlightsField.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsField.vue?vue&type=style&index=0&id=464c8458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c8458",
  null
  
)

export default component.exports